import React, { useState } from "react";
import { Badge, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

const ApplicantData = ({ user,applicant }) => {
  const educations = user?.personal_educations || [];
  const laboralExperiences = user?.laboral_experiences || [];

  const fullCvUrl = user.cv_url;
  const educationPairs = educations
    .map(e => ({
      profesion: e.career_name || e.education_career || "",
      institucion: e.institution_name || e.education_institution || ""
    }))
    .filter(e => e.profesion || e.institucion);

  const laboralPairs = laboralExperiences
    .map(e => ({
      profesion: e.company_position || "",
      institucion: e.company_name || ""
    }))
    .filter(e => e.profesion || e.institucion);

  const combinedList = educationPairs.length > 0 ? educationPairs : laboralPairs;
  const main = combinedList[0] || { profesion: "No ingresó", institucion: "No ingresó" };
  const extra = combinedList.slice(1);

  const lastJob = laboralExperiences.length > 0 ? laboralExperiences[laboralExperiences.length - 1] : null;
  const lastPosition = lastJob
    ? `${lastJob.company_position || "No ingresó"}${lastJob.company_name ? " en " + lastJob.company_name : ""}`
    : "No ingresó";

  const pi = user?.personal_information || {};
  const name = pi.social_name
    ? `${pi.social_name} ${pi.last_name || ""}`.trim()
    : `${pi.first_name || ""} ${pi.middle_name || ""} ${pi.last_name || ""}`.trim();

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="media flex-wrap applicant-data">
      <div className="media-body ms-3">
        <h2 className="h5 mb-2 __force-text_break-word fw-bold">
          {name ? name : (user.email || pi.last_email || "")}
          { applicant.type == "Trabajando::Postulation" && (
            <img
              src={ RAILS_ASSET_URL('/images/trabajando_active_icon64.png') }
              alt="Trabajando"
              className="trabajando-icon ms-1"
            />
          )}
        </h2>
        <ul className="fa-ul list-unstyled mb-0 ms-4 publication-detail-list __force-text_break-word">
          <li>
            <span className="fa-li">
              <i aria-hidden="true" className="fas fa-user-graduate" title="Profesión"></i>
            </span>
            <strong>Profesión:</strong>{" "}
            {main.profesion} <span className="text-muted">({main.institucion})</span>
            {extra.length > 0 && (
              <>
                {" "}
                <Button color="link" size="sm" onClick={() => setModalOpen(true)}>
                  Ver todas
                </Button>
                <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
                  <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
                    Todas las formaciones/profesiones
                  </ModalHeader>
                  <ModalBody>
                    <ul className="list-unstyled">
                      {combinedList.map((item, idx) => (
                        <li key={idx} className="mb-2">
                          <i className="fas fa-user-graduate me-2"></i>
                          <strong>{item.profesion || "No ingresó"}</strong>
                          <span className="text-muted ms-2">
                            {item.institucion ? `(${item.institucion})` : ""}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </ModalBody>
                </Modal>
              </>
            )}
          </li>
          <li>
            <span className="fa-li">
              <i aria-hidden="true" className="fas fa-briefcase" title="Último Cargo"></i>
            </span>
            <strong>Último cargo: </strong>
            {lastPosition}
          </li>
          <li>
            <span className="fa-li">
              <i aria-hidden="true" className="fas fa-file-alt" title="Curriculum"></i>
            </span>
            <strong>Curriculum: </strong>
            {user.cv_url ? (
              <a href={user.cv_url} target="_blank" rel="noopener noreferrer">
                ver
              </a>
            ) : (
              "No ingresado"
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ApplicantData;
